<template>
  <span class="user-status">
    <v-chip small outline color="success"
      v-if="status == 'closed'" disabled>Resolvido</v-chip>
    <v-chip small outline color="red"
      v-if="status == 'open'" disabled>Em aberto</v-chip>
  </span>
</template>

<script>
export default {
  props: {
    status: String
  }
}
</script>

<style>
.user-status .chip {
  width: 100%;
  text-align: center;
}

.user-status .chip__content {
  width: 100%;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/support/AdminTicketStatusLabel.vue